<script setup lang="ts">
const menuVisible = ref(false);
const route = useRoute();

const props = defineProps({
  menu: {
    type: Array<{ id: number; name: string; slug: string }>,
    default: () => [],
  },
  showMainLogo: {
    type: Boolean,
    default: false,
  },
  mainLogoSubtitle: {
    type: [String, Boolean],
    default: false,
  },
  baseMenuItemPath: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <LazyMenuMobile :custom-menu="props.menu" v-model:visible="menuVisible" isMoto/>
  <AppHeaderBar v-if="route.name === 'index'"/>
  <div class="sticky top-0 bg-white shadow-box z-50">
    <BarBackToMainPage />
    <Container no-paddings>
      <AppHeaderMotoMenu :menu="props.menu" :base-menu-item-path="props.baseMenuItemPath" @hamburgerClick="menuVisible = !menuVisible">
        <template #custom-logo v-if="$slots['custom-logo']">
          <slot name="custom-logo" />
        </template>
      </AppHeaderMotoMenu>
    </Container>
  </div>
</template>
